import type { DrawerProps } from "@mui/material/Drawer";
import MuiDrawer from "@mui/material/Drawer";
import type { FunctionComponent } from "react";

import { ZIndexLayer } from "~/lib/styles";

import CloseIcon from "./icon-close.svg";
import { DrawerCard, DrawerCardHeader, DrawerCardTitle, DrawerCloseContainer } from "./styles";

export type Props = {
  title?: string;
  withClose?: boolean;
} & DrawerProps;

export const Drawer: FunctionComponent<Props> = ({
  anchor = "bottom",
  children,
  onClose,
  PaperProps = {},
  sx = {},
  title,
  withClose,
  ...props
}) => (
  <MuiDrawer
    anchor={anchor}
    PaperProps={{
      ...PaperProps,
    }}
    sx={{
      zIndex: `${ZIndexLayer.Drawer}`,
      ...sx,
    }}
    onClose={onClose}
    {...props}
  >
    <DrawerCard>
      <DrawerCardHeader>
        {title && <DrawerCardTitle>{title}</DrawerCardTitle>}

        {withClose && (
          <DrawerCloseContainer>
            <CloseIcon
              onClick={event => {
                onClose && onClose(event, "backdropClick");
              }}
            />
          </DrawerCloseContainer>
        )}
      </DrawerCardHeader>

      {children}
    </DrawerCard>
  </MuiDrawer>
);

Drawer.displayName = "Drawer";
